dataLayer = [];

// custom event and page tracking helper functions
var customGATracking = {

    // track a specific event then redirect to new location if needed
    eventTrack: function (cat, act, opt_label, opt_value, follow) {
        if (!follow) follow = false;
        dataLayer.push({
            'event': 'GAEvent',
            'uaCat': cat,
            'uaAct': act,
            'uaOptLabel': opt_label,
            'uaOptValue': opt_value
        });
        if (follow !== false) {
            window.location = follow;
            return false;
        }
    },

    // track a custom page view
    pageTrack: function (uri) {
        dataLayer.push({
            'event': 'VirtualPageview',
            'vpURI': uri,
            'vpTitle': 'Virtual Page View - Cart'
        });

    },
    // track a custom page view
    cartRecord: function (bdDomainName, bdLeadData) {
        dataLayer.push({
            'event': 'cartRecord',
            'bdDomainName': bdDomainName,
            'bdLeadData': bdLeadData
        });

    },
    addTrans: function (transData) {
        var products = [];
        var tracking_params = angular.fromJson(transData.cart.tracking_params);
        var utm_campaign = tracking_params.utm_campaign;
        angular.forEach(transData.domains, function (item) {
            products.push({
                'name': item.name,
                'id': '',
                'price': item.price,
                'brand': utm_campaign,
                'category': item.category,
                'variant': ' ',
                'quantity': 1,
                'metric1': item.listing_price,
                'metric2': ''
            });
        });

        var ecomData = {
            'event': 'GAOrderCompleted',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': transData.cart.cart_token,
                        'affiliation': 'BuyDomains Cart',
                        'revenue': transData.cart.total,
                        'tax': '',
                        'shipping': 'shipping'
                    },
                    'products': products
                }
            }
        };

        if (!(transData.coupon === undefined || transData.coupon === '')) {
            ecomData.ecommerce.purchase.actionField.coupon = transData.coupon.code;
        }
        dataLayer.push(ecomData);
    },

    // Track specific links being clicked
    linkEvent: function (cat, act, val, uri) {
        customGATracking.eventTrack(cat, act, val);
        setTimeout(function () {
            window.location = uri;
        }, 500);
        return false;
    },
    gaStartTime: false,
    gaTimer: {
        'start': 0,
        'end': 0
    },
    gaTrackTiming: function (event, category, el, label) {
        var endTime = new Date().getTime();
        var timeSpent = endTime - customGATracking.gaStartTime;
        ga('send', 'timing', category, el, timeSpent, label);
    },
    gaStartTiming: function () {
        customGATracking.gaStartTime = new Date().getTime();
    },
    startTimer: function () {
        customGATracking.gaTimer.start = new Date().getTime();
    },
    endTimer: function (cat, el) {
        customGATracking.gaTimer.end = new Date().getTime();
        var tdiff = customGATracking.gaTimer.end - customGATracking.gaTimer.start;
        ga('send', 'timing', timingCategory, timingVariable, timingValue, optLabel);
    }
};
